/**
 * @file Product assets which help us to enable/disable features
 * based on the response from the product-asset-java endpoint
 */
export const FHA_FEATURE = 'FieldHealthAdvisor';
export const FVSD_FEATURE = 'FieldViewSpatialDisplay';
export const CROP_WATER_FEATURE = 'CropWaterUseMap';
export const FIELD_REGION_REPORT_FEATURE = 'FieldRegionReport';
export const YIELD_ANALYSIS_FEATURE = 'YieldAnalysis';
export const SCOUTING_FEATURE = 'Scouting';
